import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx'; // Correctly imports your main component
import './index.css'; // Imports the CSS (where Tailwind is configured)

// The root element to render the app into
const rootElement = document.getElementById('root');
if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        {/* Only rendering your primary App component */}
        <App />
      </React.StrictMode>,
    );
}
